import type { NextPage } from 'next'

import { homeRenovationLoan } from 'data/seo/home-renovation-loan'
import { HomeRenovationLoan } from 'views/home-renovation-loan'

const HomeRenovationLoanPage: NextPage = () => <HomeRenovationLoan />

export default HomeRenovationLoanPage

export async function getStaticProps() {
  return {
    props: { SEO: homeRenovationLoan }
  }
}
